<div *transloco="let t">
  <button
    [matMenuTriggerFor]="menu"
    class="flex h-11 items-center gap-2 px-4 py-2 text-base font-medium text-ink-muted rounded-lg border border-stroke-soft"
  >
    <span>{{ t(selectedDateRange().label) }}</span>
    <img height="12" width="12" src="/images/icons/chevron-down.svg" alt="chevron-down" />
  </button>

  <mat-menu #menu="matMenu" class="w-60 no-menu-padding mt-2">
    <ul class="divide-y-2 divide-gray-100">
      @for (option of dateRanges(); track $index) {
      <li class="px-3 py-2 hover:bg-surface-card" [class.bg-surface-card]="option === selectedDateRange()">
        <button (click)="selectDateRange(option)" class="w-full h-10 text-start flex flex-col justify-center">
          <span class="text-sm me-6">{{ t(option.label) }}</span>
          @if (option.value !== DateRange.AllTime) {
          <span class="text-xs text-ink-subtle">
            {{ option.rangeStart! | translocoDate : { dateStyle: 'medium' } }} -
            {{ option.rangeEnd! | translocoDate : { dateStyle: 'medium' } }}</span
          >
          }
        </button>
      </li>
      }
    </ul>
  </mat-menu>
</div>
